import { CT_PICK_3, INSTANT_SLUG_GAME } from '@/constants/lotto';
import languageMixins from '@/mixins/language/language-mixins';
import { formatDateUTC00, isStrEmpty, formatPrice, formatFromUTCStringToFrCustomString, getSettingDevice, splitDataLottoInstant } from '@/utils/utils';
import LastResultService from '@/services/last-result.service';
import { buildSimulateErrorField } from '@/utils/print-debug';

const LOGO_URL_LOTTO = process.env.VUE_APP_LOGO_LOTTO_URL;
const LOGO_URL_SPORT = process.env.VUE_APP_LOGO_SPORT_URL;

const LOGO_64_LOTTO = process.env.VUE_APP_LOGO_LOTTO_64;
const LOGO_64_SPORT = process.env.VUE_APP_LOGO_SPORT_64;

let logoKey, LOTTO_LOGO, SPORT_LOGO = '';

if (LOGO_64_LOTTO && LOGO_64_LOTTO !== '' && LOGO_64_SPORT && LOGO_64_SPORT !== '') {
    logoKey = 'logo64';
    LOTTO_LOGO = LOGO_64_LOTTO
    SPORT_LOGO = LOGO_64_SPORT
} else {
    logoKey = 'logo';
    LOTTO_LOGO = LOGO_URL_LOTTO
    SPORT_LOGO = LOGO_URL_SPORT
}

// const LOGO_PRINT = process.env.VUE_APP_LOGO_LOTTO_64;
// const LOGO_SPORT_PRINT = process.env.VUE_APP_LOGO_SPORT_64;

export default {
    mixins: [languageMixins],
    data() {
        return {};
    },
    methods: {
        printBodyLottoQuickLottery(param) {
            const body = []
            let winnings = 0
            let wager = 0
            for (let index = 0; index < param.bets.entries.length; index++) {
                const element = param.bets.entries[index]

                winnings += parseFloat(element.winnings)
                wager += parseFloat(element.entry.wager)

                const gameName = element.game.game.toUpperCase()

                const drawDateFormat = formatDateUTC00(new Date())

                const drawDate = `${drawDateFormat.day}/${drawDateFormat.month}/${drawDateFormat.year} ${drawDateFormat.hour}:${drawDateFormat.minutes}`

                const dataBet = element.entry.bet[0]

                const result = !isStrEmpty(element.result) ? JSON.parse(element.result) : []

                const betNumberFirst = splitDataLottoInstant(1, dataBet).join(' ')
                const betNumberLast = splitDataLottoInstant(2, dataBet).join(' ')

                const itemBody = [
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('Your numbers'),
                        fontSize: 28,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: betNumberFirst,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: betNumberLast,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    // {
                    //     type: 'printEmptyLines',
                    //     line: 1,
                    // },
                    // {
                    //     type: 'printTextCustom',
                    //     value: `${this.getTranslatedText('draw date')}:${drawDate}`,
                    //     fontSize: 20,
                    //     isUnderline: false,
                    //     alignment: 0,
                    // },
                    // {
                    //     label: `${this.getTranslatedText('draw date')}:`,
                    //     value: `${drawDate}`,
                    //     type: 'printTable',
                    //     column: [4, 3],
                    //     align: [0, 2],
                    //     isUnderline: false,
                    // },
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('draw number'),
                        fontSize: 28,
                        isUnderline: false,
                        alignment: 1,
                    },
                ]

                for (let i = 0; i < result.length; i += 5) {
                    const columnResult = {
                        type: 'printTextCustom',
                        value: result.slice(i, i + 5).join(' '),
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    }
                    itemBody.push(columnResult)
                }

                const itemPrice = [
                    {
                        label: `${this.getTranslatedText('wager')}:`,
                        value: `${formatPrice(element.entry.wager)}`,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('winnings')}:`,
                        value: `${formatPrice(element.winnings)}`,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                ]

                itemBody.push(...itemPrice)

                if (param.bets.entries.length - 1 !== index) {
                    itemBody.push({
                        type: 'printEmptyLines',
                        line: 1,
                    })
                }

                body.push(...itemBody)
            }

            const itemPrice = [
                {
                    type: 'printDashLine',
                },
                {
                    label: `${this.getTranslatedText('total wager')}:`,
                    value: `${formatPrice(wager)}`,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('total winnings')}:`,
                    value: `${formatPrice(winnings)}`,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
            ]

            body.push(...itemPrice)

            return body
        },

        printBodyLotto(param, isHiddenDrawName = false, isShowMarketName = false) {
            const body = []
            for (let index = 0; index < param.bets.entries.length; index++) {
                const element = param.bets.entries[index]

                let gameName = element.game.game.replace(/-/g, ' ').toUpperCase()
                gameName = gameName.replace('LOTTO GUINEE', 'LOTO FORTUNE')
                gameName = this.getTranslatedText(gameName.toLowerCase())
                let doubleChance = "";
                if ((element.market?.market_option || '') == 'double_chance') {
                    doubleChance = this.getTranslatedText(element.market?.market_option).toUpperCase()
                }
                gameName = gameName.toUpperCase();

                let jackpot = element.game.jackpot

                const drawDateFormat = formatDateUTC00(element.event.drawDate)

                const drawDate = `${drawDateFormat.day}/${drawDateFormat.month}/${drawDateFormat.year} ${drawDateFormat.hour}:${drawDateFormat.minutes}`

                let numberTicket = element.entry.bet[0].join(', ')
                if (element.entry.bet[1]) {
                    numberTicket = numberTicket + ' - ' + element.entry.bet[1].join(', ')
                }

                const itemBody = [
                    {
                        type: 'printTextCustom',
                        value: gameName,
                        fontSize: 30,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: numberTicket,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'setFontSize',
                        size: 25,
                    },
                    {
                        label: `${this.getTranslatedText('wager')}:`,
                        value: `${formatPrice(element.entry.wager)}`,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                        columnName: 'wager'
                    },
                    {
                        label: `${this.getTranslatedText('draw name')}:`,
                        value: `${element.event.drawName}`,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                        columnName: 'draw name',
                    },
                    {
                        label: `${this.getTranslatedText('draw date')}:`,
                        value: `${drawDate.split(' ')[0]}`,
                        type: 'printTable',
                        column: [4, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: ``,
                        value: `${drawDate.split(' ')[1]}`,
                        type: 'printTable',
                        column: [4, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                ]

                if (isShowMarketName && !isStrEmpty(element.market?.marketName)) {
                    const index = itemBody.findIndex((item) => item?.columnName === 'wager')
                    if (index !== -1) {
                        const itemMarket = {
                            label: `${this.getTranslatedText('market')}:`,
                            value: `${this.getTranslatedText(element.market.marketName)}`,
                            type: 'printTable',
                            column: [2, 4],
                            align: [0, 2],
                            isUnderline: false,
                        }
                        itemBody.splice(index + 1, 0, itemMarket)
                    }
                }

                if (doubleChance != '') {
                    itemBody.splice(1, 0, {
                        type: 'printTextCustom',
                        value: doubleChance,
                        fontSize: 30,
                        isUnderline: false,
                        alignment: 1,
                    });
                }

                const boostCategoryName = element.entry?.boost_category_name || ''
                if (boostCategoryName !== '') {
                    itemBody.splice(1, 0, {
                        type: 'printTextCustom',
                        value: boostCategoryName.toUpperCase(),
                        fontSize: 30,
                        isBold: true,
                        isUnderline: false,
                        alignment: 1,
                    });
                }

                if(isHiddenDrawName) {
                    const index = itemBody.findIndex((item) => item?.columnName === 'draw name')
                    if(index !== -1) {
                        const itemMarket = {}
                        itemBody.splice(index, 1)
                    }
                }

                if (element.event.drawName.length > 14 && !isHiddenDrawName) {
                    const indexToReplace = itemBody.findIndex((item) => item?.columnName === 'draw name')

                    const newColumn = [
                        {
                            type: 'setAlignLeft',
                        },
                        {
                            label: `${this.getTranslatedText('draw name')}:`,
                            value: ``,
                            type: 'printTable',
                            column: [5, 1],
                            align: [0, 2],
                            isUnderline: false,
                        },
                        {
                            type: 'setAlignRight',
                        },
                        {
                            label: ``,
                            value: `${element.event.drawName}`,
                            type: 'printTable',
                            column: [1, 5],
                            align: [0, 2],
                            isUnderline: false,
                        },
                        {
                            type: 'setAlignCenter',
                        },
                    ]
                    itemBody.splice(indexToReplace, 1, ...newColumn)
                }

                if (jackpot) {
                    itemBody.push({
                        type: 'printTextCustom',
                        value: `Jackpot: ${formatPrice(parseFloat(jackpot))}`,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    })
                }

                if (param.bets.entries.length - 1 !== index) {
                    itemBody.push({
                        type: 'printEmptyLines',
                        line: 1,
                    })
                }

                if (param.isCombinations && element.type && element.combinations) {
                    const itemComninations = [
                        {
                            label: `${this.getTranslatedText('type')}:`,
                            value: `${element.type}`,
                            type: 'printTable',
                            column: [2, 4],
                            align: [0, 2],
                            isBold: true,
                            isUnderline: false,
                        },
                        {
                            label: `${this.getTranslatedText('combinations')}:`,
                            value: `${element.combinations}`,
                            type: 'printTable',
                            column: [4, 2],
                            align: [0, 2],
                            isBold: true,
                            isUnderline: false,
                        },
                    ]

                    itemBody.splice(3, 0, ...itemComninations)
                }

                body.push(...itemBody)
            }

            const bodyFooter = [
                {
                    type: 'printDashLine',
                },
            ];

            body.push(...bodyFooter);

            return body
        },

        resolveGameSlug(param) {
            // Try additionalInformation.game_slug first (works for pick3, instant)
            const gameSlug = param?.transaction?.additionalInformation?.game_slug;
            if (gameSlug) {
                const resolved = LastResultService.slugFor(gameSlug);
                if (resolved) return resolved;
            }
            // Fallback: reverse-lookup from translated game name
            const translatedName = param?.bets?.entries?.[0]?.game?.game;
            if (!translatedName) return null;
            const knownSlugs = [
                'loto-590', 'lotto-6-45', 'loto-4-59', 'lotto-5-45', 'pick-3-lotto-guinee',
                'turbo-2', 'turbo-3', 'turbo-4', 'turbo-5',
                'nap-2', 'nap-3', 'nap-4', 'nap-5',
                'chance-3', 'chance-4', 'chance-5',
                'extra-6', 'extra-7',
                'lotto-guinee-5-90-turbo2', 'lotto-guinee-5-90-turbo3', 'lotto-guinee-5-90-turbo4', 'lotto-guinee-5-90-turbo5',
                'lotto-guinee-5-90-nap2', 'lotto-guinee-5-90-nap3', 'lotto-guinee-5-90-nap4', 'lotto-guinee-5-90-nap5',
                'lotto-guinee-5-90-chance3', 'lotto-guinee-5-90-chance4', 'lotto-guinee-5-90-chance5',
                'lotto-guinee-5-90-extra6', 'lotto-guinee-5-90-extra7',
            ];
            for (const slug of knownSlugs) {
                if (this.getTranslatedText(slug) === translatedName) {
                    return LastResultService.slugFor(slug);
                }
            }
            return null;
        },

        pushLastDrawResultBlock(data, entry, isPick3 = false) {
            if (!entry) return;

            const drawDateFormat = formatDateUTC00(entry.draw_date);
            const headerLine = `${this.getTranslatedText('last draw result')} – ${drawDateFormat.day}/${drawDateFormat.month}/${drawDateFormat.year} ${drawDateFormat.hour}:${drawDateFormat.minutes}`;

            let mainNumbers;
            if (isPick3 && entry.results && entry.results[0]) {
                mainNumbers = Array.isArray(entry.results[0])
                    ? entry.results[0].join(' – ')
                    : String(entry.results[0]).split('').join(' – ');
            } else {
                mainNumbers = entry.results && entry.results[0]
                    ? entry.results[0].map(n => String(n).padStart(2, '0')).join(' – ')
                    : '';
            }

            data.push(
                // { type: 'printEmptyLines', line: 1 },
                { type: 'printDashLine' },
                { type: 'printTextCustom', value: headerLine, fontSize: 22, isBold: true, isUnderline: false, alignment: 1 },
                { type: 'printTextCustom', value: mainNumbers, fontSize: 26, isBold: true, isUnderline: false, alignment: 1 },
            );

            if (entry.double_chance_results && entry.double_chance_results.length > 0) {
                const dcNumbers = entry.double_chance_results[0].map(n => String(n).padStart(2, '0')).join(' – ');
                data.push(
                    { type: 'printTextCustom', value: `${this.getTranslatedText('double chance')}`, fontSize: 18, isUnderline: false, alignment: 1 },
                    { type: 'printTextCustom', value: dcNumbers, fontSize: 22, isBold: true, isUnderline: false, alignment: 1 },
                );
            }

            data.push({ type: 'printDashLine' });
        },

        printLoto(param, isReprint = false) {
            let isTacTac = false;
            try {
                isTacTac = param?.transaction?.additionalInformation?.game_slug == INSTANT_SLUG_GAME
            } catch { }

            if (isTacTac) return this.printTacTacLoto(param, isReprint)

            let isPick3 = false
            try {
                isPick3 = param?.transaction?.additionalInformation?.game_slug == CT_PICK_3.SLUG_GAME
            } catch { }

            if (isPick3) return this.printPick3(param, isReprint)

            const isCheckFormatQuickLottery = param.bets.entries.some(
                (bet) => bet.game.game == this.getTranslatedText(INSTANT_SLUG_GAME)
            )

            let font = this.isCheckFontMobile()

            let printerData = {};

            let ticketId = isCheckFormatQuickLottery ? param.transaction.external_id : param.transaction.transaction_id;

            const dateFormat = formatDateUTC00(new Date());

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            if (!isStrEmpty(ticketId)) {
                if (!ticketId.toString().startsWith('L-')) ticketId = 'L-' + ticketId;
            }

            printerData["init"] = [
                {
                    type: "setAlignCenter",
                },
            ]

            printerData[logoKey] = LOTTO_LOGO;

            printerData['header'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: valueDate,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: ticketId,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'qrcode',
                    value: ticketId,
                },
            ];

            if (param.raffle_print_data && param.raffle_print_data.length > 0) {
                printerData['header'] = printerData['header'].concat([
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('raffle entry code')}`,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: param.raffle_code,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                ]);
            }

            // printerData['header'] = printerData['header'].concat([
            //     {
            //         type: 'printDashLine',
            //     },
            //     {
            //         type: 'printEmptyLines',
            //         line: 1,
            //     },
            // ]);

            printerData['titleBody'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('guinee lottery')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                },
            ];

            if (isReprint) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('reprint')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                };
                printerData['titleBody'].splice(1, 0, item);
            }

            const body = isCheckFormatQuickLottery ? this.printBodyLottoQuickLottery(param) : this.printBodyLotto(param)

            printerData['footer'] = [
                {
                    type: 'setFontSize',
                    size: 30,
                }
            ]

            if (!isCheckFormatQuickLottery) {
                printerData['footer'].push({
                    label: `${this.getTranslatedText('total')}:`,
                    value: `${formatPrice(param.transaction.total, 2)} ${param.transaction.currency}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                })
            }

            if (param.raffle_print_data && param.raffle_print_data.length > 0) {
                printerData['footer'].push({
                    type: 'printDashLine',
                })
                printerData['footer'].push({
                    type: 'printEmptyLines',
                    line: 1,
                })

                printerData['footer'] = printerData['footer'].concat([
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('raffle entry code')}`,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: param.raffle_code,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                ]);

                param.raffle_print_data.forEach(e => {
                    let str = this.getTranslatedText(e.text)
                    if (e.replaces && e.replaces.length > 0) {
                        // format string
                        e.replaces.forEach(s => {
                            str = str.replace('%s', s)
                        })
                    }

                    printerData['footer'].push({
                        type: 'printTextCustom',
                        value: str,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    })
                });
                printerData['footer'].push({
                    type: 'printDashLine',
                })
            }

            if (isReprint) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('reprint')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                };
                printerData['footer'].push(item);
            }

            printerData['footer'] = printerData['footer'].concat([
                {
                    type: 'barcode',
                    value: ticketId,
                    isShowCode: true,
                    fontSize: 25,
                    height: 80
                },
            ]);

            // Last draw result block — position D (below barcode, above promos)
            const entrySlug = this.resolveGameSlug(param);
            const lastResultEntry = LastResultService.getLastResultBlock(entrySlug);
            this.pushLastDrawResultBlock(printerData['footer'], lastResultEntry);

            printerData['footer'] = printerData['footer'].concat([
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('consultez vos résultats du loto')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Gains valides pendant 7 jours')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Fortune aux parieurs et')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Bénéfice à la Nation')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                // {
                //     type: 'printTextCustom',
                //     value: `Oui pour une Constitution qui nous`,
                //     isBold: true,
                //     fontSize: 20,
                //     isUnderline: false,
                //     alignment: 1,
                //     font: font // make it smaller on mobi only
                // },
                // {
                //     type: 'printTextCustom',
                //     value: `ressemble et nous rassemble.`,
                //     isBold: true,
                //     fontSize: 20,
                //     isUnderline: false,
                //     alignment: 1,
                //     font: font // make it smaller on mobi only
                // },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('end')}`,
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'cutPaper',
                },
            ]);

            printerData['body'] = body;
            parent.postMessage({ command: 'print-by-format', data: printerData, ...buildSimulateErrorField() }, '*');
        },

        printTacTacLoto(param, isReprint = false) {
            const isCheckFormatQuickLottery = param.bets.entries.some(
                (bet) => bet.game.game == this.getTranslatedText(INSTANT_SLUG_GAME)
            )

            let printerData = {};

            let ticketId = param.transaction.external_id;

            const dateFormat = formatDateUTC00(new Date());

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            if (!isStrEmpty(ticketId)) {
                if (!ticketId.toString().startsWith('L-')) ticketId = 'L-' + ticketId;
            }

            printerData["init"] = [
                {
                    type: "setAlignCenter",
                },
            ]

            printerData[logoKey] = LOTTO_LOGO;

            printerData['header'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: valueDate,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: ticketId,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'qrcode',
                    value: ticketId,
                },
            ];

            printerData['titleBody'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('TAC TAC GAME')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                },
                // {
                //     type: 'printEmptyLines',
                //     line: 1,
                // },
            ];

            const body = this.printBodyLottoQuickLottery(param)

            printerData['footer'] = [
                {
                    type: 'setFontSize',
                    size: 30,
                }
            ]

            printerData['footer'] = printerData['footer'].concat([
                {
                    type: 'barcode',
                    value: ticketId,
                    isShowCode: true,
                    fontSize: 25,
                    height: 80
                },
                {
                    type: 'cutPaper',
                },
            ]);

            printerData['body'] = body;

            parent.postMessage({ command: 'print-by-format', data: printerData, ...buildSimulateErrorField() }, '*');
        },

        printPick3(param, isReprint = false) {
            let font = this.isCheckFontMobile()

            let printerData = {};

            let ticketId =  param.transaction.externalID;

            const dateFormat = formatDateUTC00(new Date());

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            if (!isStrEmpty(ticketId)) {
                if (!ticketId.toString().startsWith('L-')) ticketId = 'L-' + ticketId;
            }

            printerData["init"] = [
                {
                    type: "setAlignCenter",
                },
            ]

            printerData[logoKey] = LOTTO_LOGO;

            printerData['header'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: valueDate,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: ticketId,
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'qrcode',
                    value: ticketId,
                },
            ];

            printerData['titleBody'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('guinee lottery')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                },
            ];

            if (isReprint) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('reprint')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                };
                printerData['titleBody'].splice(1, 0, item);
            }

            const body = this.printBodyLotto(param, true, true)

            printerData['footer'] = [
                {
                    type: 'setFontSize',
                    size: 30,
                }
            ]

            if (isReprint) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('reprint')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                };
                printerData['footer'].push(item);
            }

            printerData['footer'] = printerData['footer'].concat([
                {
                     label: `${this.getTranslatedText('total')}:`,
                    value: `${formatPrice(param.transaction.total, 2)} ${param.transaction.currency}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    type: 'barcode',
                    value: ticketId,
                    isShowCode: true,
                    fontSize: 25,
                    height: 80
                },
            ]);

            // Last draw result block — Pick-3 with space-separated digits
            const pick3Slug = LastResultService.slugFor('pick-3-lotto-guinee');
            const pick3Entry = LastResultService.getLastResultBlock(pick3Slug);
            this.pushLastDrawResultBlock(printerData['footer'], pick3Entry, true);

            printerData['footer'] = printerData['footer'].concat([
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('consultez vos résultats du loto')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Gains valides pendant 7 jours')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Fortune aux parieurs et')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('Bénéfice à la Nation')}`,
                    fontSize: 20,
                    isUnderline: false,
                    alignment: 1,
                    font: font // make it smaller on mobi only
                },
                // {
                //     type: 'printTextCustom',
                //     value: `Oui pour une Constitution qui nous`,
                //     isBold: true,
                //     fontSize: 20,
                //     isUnderline: false,
                //     alignment: 1,
                //     font: font // make it smaller on mobi only
                // },
                // {
                //     type: 'printTextCustom',
                //     value: `ressemble et nous rassemble.`,
                //     isBold: true,
                //     fontSize: 20,
                //     isUnderline: false,
                //     alignment: 1,
                //     font: font // make it smaller on mobi only
                // },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('end')}`,
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'cutPaper',
                },
            ]);

            printerData['body'] = body;
            parent.postMessage({ command: 'print-by-format', data: printerData, ...buildSimulateErrorField() }, '*');
        },

        printSports(printParam, isReprint = false) {
            const betStorage = JSON.parse(printParam);
            const voucher = betStorage[0].voucher;
            const transactions = betStorage[0].transactions;
            let printerData = {};

            printerData["init"] = [
                {
                    type: "setAlignCenter",
                },
            ]

            printerData[logoKey] = SPORT_LOGO;

            printerData['title'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('SPORTS TICKET'),
                    fontSize: 35,
                    fontSizeMobi: 1, // 0 ~ 5
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
            ];

            if (isReprint) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('reprint')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                    fontSizeMobi: 1, // 0 ~ 5
                };
                printerData['title'].splice(3, 0, item);
            }

            for (const transaction of transactions) {
                const fontSize = 25;

                let winningAfterTax = formatPrice(parseFloat(transaction.winning_after_tax));
                let totalOdds = formatPrice(parseFloat(transaction.odds_total));
                let wager = formatPrice(parseFloat(transaction.stake));
                const bets = transaction.bets;
                printerData['header'] = [
                    {
                        type: 'setAlignLeft',
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('Date')}: ${voucher.created_at.split('.')[0]}`,
                        fontSize,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('betslip id')}: ${transaction.external_bet_id}`,
                        fontSize,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'qrcode',
                        value: transaction.external_bet_id.startsWith('S-') ? transaction.external_bet_id : `S-${transaction.external_bet_id}`,
                    },
                ];

                let typeBeslip = '';

                if (transaction.bets.length > 1) {
                    typeBeslip = `---${this.getTranslatedText('Multiple')} : (${transaction.bets.length}) ${this.getTranslatedText('lines').toString().toLowerCase()}---`;
                } else {
                    typeBeslip = `------ ${this.getTranslatedText('Simple')} ------`;
                }

                printerData['titleBody'] = [
                    {
                        type: 'setAlignCenter',
                    },
                    {
                        type: 'printTextCustom',
                        value: typeBeslip,
                        fontSize: 25,
                        alignment: 1,
                    },
                    {
                        type: 'setAlignLeft',
                    },
                ];
                let body = [];
                for (var b = 0; b < bets.length; b++) {
                    let item = [
                        {
                            type: 'printTextCustom',
                            value: `${transaction.bets.length > 1 ? '[' + (b + 1) + '] ' : ''}${transaction.bets[b].tournament_name}`,
                            fontSize: 22,
                            isUnderline: false,
                        },
                        {
                            type: 'printTextCustom',
                            value: `${bets[b].match_name_no_date || bets[b].match_name}`,
                            fontSize: 22,
                            isBold: false,
                            isUnderline: false,
                        },
                        {
                            type: 'printTextCustom',
                            value: `${bets[b].draw_time}`,
                            fontSize: 22,
                            isBold: false,
                            isUnderline: false,
                        },
                        {
                            type: 'printTextCustom',
                            value: `${bets[b].market_name}: ${bets[b].outcome_name} @ ${bets[b].odd}`,
                            fontSize: 22,
                            isBold: false,
                            isUnderline: false,
                        },
                    ];
                    if (b <= bets.length - 2) {
                        let items = {
                            type: 'printCutDashLine',
                        };
                        item.push(items);
                    }
                    body.push(...item);
                }
                const footer = [
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('Total odds')}: ${totalOdds}`,
                        fontSize,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('Wager')}: ${wager}`,
                        fontSize,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('possible winnings')}: ${winningAfterTax}`,
                        fontSize,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'setAlignCenter',
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'barcode',
                        value: transaction.external_bet_id.startsWith('S-') ? transaction.external_bet_id : `S-${transaction.external_bet_id}`,
                        isShowCode: true,
                        codePosition: '',
                        fontSize: 25,
                        height: 80
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('end')}`,
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'cutPaper',
                        value: ''
                    },
                ];

                if (isReprint) {
                    let item = {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('reprint')}`,
                        fontSize: 35,
                        isBold: true,
                        isUnderline: false,
                        alignment: 1,
                        fontSizeMobi: 1, // 0 ~ 5
                    };
                    footer.splice(6, 0, item);
                }

                printerData['body'] = body;
                printerData['footer'] = footer;
            }

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        printSettle(printParam) {
            let printerData = {};

            let date = formatDateUTC00(new Date());
            let datePrint = `${date.day}/${date.month}/${date.year} ${date.hour}:${date.minutes}`;

            printerData[logoKey] = LOTTO_LOGO;

            printerData['body'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('receipt'),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignLeft',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('date')}: ${datePrint}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('branch')}: ${printParam.branch_name}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('cashier')}: ${printParam.cashier_name}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('code')}: ${printParam.code}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('settlement')}: ${printParam.currency_code + ' ' + formatPrice(parseFloat(printParam.winnings))}`,
                    alignment: 0,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'barcode',
                    value: printParam.code,
                    isShowCode: true,
                    height: 80,
                    fontSize: 25
                },
                {
                    type: 'cutPaper',
                },
            ];

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        printFreebetCoupon(coupon) {
            let printerData = {};

            // Print the coupon's issue date (created_at) so it lines up with the
            // expiry (issue + validity days). Fall back to now() only if the API
            // didn't supply created_at.
            let date = formatDateUTC00(coupon.created_at ? coupon.created_at : new Date());
            let datePrint = `${date.day}/${date.month}/${date.year} ${date.hour}:${date.minutes}`;

            let expiresPrint = '';
            try {
                if (coupon.expires_at) {
                    let e = formatDateUTC00(coupon.expires_at);
                    expiresPrint = `${e.day}/${e.month}/${e.year} ${e.hour}:${e.minutes}`;
                }
            } catch (err) {
                expiresPrint = coupon.expires_at || '';
            }

            printerData[logoKey] = LOTTO_LOGO;

            printerData['body'] = [
                { type: 'setAlignCenter' },
                { type: 'printEmptyLines', line: 1 },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('guinee lottery')}`,
                    fontSize: 35,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                ...(() => {
                    // Split the coupon title across two lines on a word boundary so the
                    // printer's narrow width never breaks the title mid-phrase. The
                    // "- 4 Numéros" suffix rides on the second line.
                    const words = this.getTranslatedText('extra7 boost freebet coupon').split(' ');
                    const mid = Math.ceil(words.length / 2);
                    const titleLines = [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
                    titleLines[1] = `${titleLines[1]} - ${this.getTranslatedText('4 numbers')}`;
                    return titleLines.map((line) => ({
                        type: 'printTextCustom',
                        value: line,
                        fontSize: 30,
                        isBold: true,
                        isUnderline: false,
                        alignment: 1,
                    }));
                })(),
                { type: 'printEmptyLines', line: 1 },
                { type: 'setAlignLeft' },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('date')}: ${datePrint}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('ticket')}: ${coupon.source_ticket_id || ''}`,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('freebet print tickets line', {
                        count: coupon.freebet_quantity,
                        amount: formatPrice(parseFloat(coupon.freebet_amount) / (coupon.freebet_quantity || 1), 0).replace(/,/g, ' '),
                        currency: coupon.currency_code || 'GNF',
                    }),
                    fontSize: 30,
                    isBold: true,
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('freebet print total value', {
                        amount: formatPrice(parseFloat(coupon.freebet_amount), 0).replace(/,/g, ' '),
                        currency: coupon.currency_code || 'GNF',
                    }),
                    alignment: 0,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('expires at')}: ${expiresPrint}`,
                    isBold: true,
                    alignment: 0,
                },
                { type: 'printEmptyLines', line: 1 },
                { type: 'setAlignCenter' },
                {
                    type: 'qrcode',
                    value: coupon.code,
                },
                {
                    type: 'barcode',
                    value: coupon.code,
                    isShowCode: true,
                    height: 80,
                    fontSize: 25,
                },
                { type: 'printEmptyLines', line: 1 },
                ...(() => {
                    // Non-cashable notice below the barcode. Split on a word boundary
                    // into balanced lines so the printer's narrow width never breaks a
                    // word mid-way.
                    const words = this.getTranslatedText('coupon not cashable notice').split(' ');
                    const mid = Math.ceil(words.length / 2);
                    return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')].map((line) => ({
                        type: 'printTextCustom',
                        value: line,
                        fontSize: 18,
                        isBold: true,
                        alignment: 1,
                    }));
                })(),
                { type: 'printEmptyLines', line: 1 },
                ...(() => {
                    // Split the closing sentence into two balanced lines on a word
                    // boundary so the printer's narrow width never breaks a word mid-way.
                    const words = this.getTranslatedText('present this coupon to play your freebet').split(' ');
                    const mid = Math.ceil(words.length / 2);
                    return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')].map((line) => ({
                        type: 'printTextCustom',
                        value: line,
                        fontSize: 18,
                        alignment: 1,
                    }));
                })(),
                { type: 'cutPaper' },
            ];

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        printReport(printParam) {
            let printerData = {};

            let currentDate = formatDateUTC00(new Date());
            let printDate = `${currentDate.day}/${currentDate.month}/${currentDate.year} ${currentDate.hour}:${currentDate.minutes}`;

            let today = `${currentDate.year}-${currentDate.month}-${currentDate.day}`;
            let trueBalance = printParam.from === printParam.to && printParam.from === today ? printParam.sum.true_balance : printParam.sum.cash_difference;
            let reports = printParam.report.filter((item) => item['product_type']);
            let reportParams = [];

            // to do report
            reports.forEach((r) => {
                let item = [
                    {
                        type: 'setAlignCenter',
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${r.product_type}`,
                        fontSize: 24,
                        isBold: true,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'setAlignLeft',
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('wager')}: ${r.currency} ${formatPrice(parseFloat(r.wagers))}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('payouts')}: ${r.currency} ${formatPrice(parseFloat(r.payouts))}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                    },
                ];

                reportParams.push(...item);
            });

            printerData[logoKey] = LOTTO_LOGO;

            printerData['body'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: printParam.isFinal ? this.getTranslatedText('final report of') : this.getTranslatedText('report of'),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printParam.cashier.first_name} ${printParam.cashier.last_name}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('report date')}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printParam.date}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('print date')}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printDate}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },

                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('summary')}`,
                    fontSize: 26,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'setAlignLeft',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('cash deposits')}: ${printParam.sum.currency} ${formatPrice(parseFloat(printParam.sum.cash_deposits))}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('cancellations')}: ${printParam.sum.currency} ${formatPrice(parseFloat(printParam.sum.refunded_cancelations))}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('payouts')}: ${printParam.sum.currency} ${formatPrice(parseFloat(printParam.sum.payouts))}`,
                    fontSize: 26,
                    isBold: false,
                    isUnderline: false,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('true balance')}: ${printParam.sum.currency} ${formatPrice(parseFloat(trueBalance))}`,
                    fontSize: 26,
                    isBold: true,
                    isUnderline: false,
                },
            ];

            printerData['body'].push(...reportParams);
            printerData['footer'] = [
                {
                    type: 'cutPaper',
                    value: ''
                },
            ];

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        printVoucher(printParam) {
            const datePrint = this.renderDatePrint(new Date(), true);
            const isPayment = printParam.isPayment;
            const isCancel = printParam.isCancel;

            const titleVoucher = isPayment ? 'lonaguiweb paiment voucher' : isCancel ? 'annulation voucher' : 'lonaguiweb voucher';

            let printerData = {};

            printerData[logoKey] = LOTTO_LOGO;

            printerData['body'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText(titleVoucher)}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    label: `${this.getTranslatedText('date')}:`,
                    value: `${datePrint}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('amount')}:`,
                    value: `${printParam.amount} ${printParam.currency}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    type: 'printDashLine',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printDashLine',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('lonaguiweb')}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'cutPaper',
                },
            ];

            if (isCancel) {
                let item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText(printParam.voucherCode)}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                };

                printerData['body'].splice(7, 0, item);
            }

            if (!isCancel && !isPayment) {
                const expirationdate = this.convertDateString(printParam.expirationdate);

                let item = {
                    label: `${this.getTranslatedText('expiry date')}:`,
                    value: `${expirationdate}`,
                    type: 'printTable',
                    column: [4, 3],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                };

                printerData['body'].splice(5, 0, item);
            }

            if (!isCancel) {
                let item = {
                    type: 'barcode',
                    value: printParam.voucherCode,
                    isShowCode: true,
                    fontSize: 25,
                    height: 80,
                    codePosition: 'above'
                };

                const locationItem = !isCancel && !isPayment ? 8 : 7;

                printerData['body'].splice(locationItem, 0, item);
            }

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        printTest() {
            let font = this.isCheckFontMobile()
            const printerData = {
                "init": [
                    {
                        "type": "setAlignCenter",
                    }],
                "logo": LOGO_URL_LOTTO,
                "header": [
                    {
                        "type": "setAlignCenter",
                    },
                    {
                        "type": "printTextCustom",
                        "value": "27/10/2023 11:19",
                        "fontSize": 25,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "printTextCustom",
                        "value": "L-FAKETICKET",
                        "fontSize": 25,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "printDashLine"
                    },
                    {
                        "type": "printEmptyLines",
                        "line": 1
                    }
                ],
                "titleBody": [
                    {
                        "type": "setAlignCenter",
                    },
                    {
                        "type": "printTextCustom",
                        "value": "LONAGUI",
                        "fontSize": 35,
                        "isBold": true,
                        "isUnderline": false,
                        "alignment": 1,
                        "fontSizeMobi": 1
                    },
                    {
                        "type": "printEmptyLines",
                        "line": 1
                    }
                ],
                "body": [
                    {
                        "type": "printTextCustom",
                        "value": "LOTO FORTUNE 5 90 TURBO3",
                        "fontSize": 30,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "printTextCustom",
                        "value": "71, 80",
                        "fontSize": 25,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "setFontSize",
                        "size": 25
                    },
                    {
                        "label": "Mise:",
                        "value": "2,000.00",
                        "type": "printTable",
                        "column": [
                            2,
                            4
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "Nom du tirage:",
                        "value": "YIGUI",
                        "type": "printTable",
                        "column": [
                            3,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "Date du tirage:",
                        "value": "28/10/2023",
                        "type": "printTable",
                        "column": [
                            4,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "",
                        "value": "09:00",
                        "type": "printTable",
                        "column": [
                            4,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "type": "printEmptyLines",
                        "line": 1
                    },
                    {
                        "type": "printTextCustom",
                        "value": "LOTO FORTUNE 5 90 TURBO3",
                        "fontSize": 30,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "printTextCustom",
                        "value": "51, 60",
                        "fontSize": 25,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "setFontSize",
                        "size": 25
                    },
                    {
                        "label": "Mise:",
                        "value": "2,000.00",
                        "type": "printTable",
                        "column": [
                            2,
                            4
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "Nom du tirage:",
                        "value": "YIGUI",
                        "type": "printTable",
                        "column": [
                            3,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "Date du tirage:",
                        "value": "28/10/2023",
                        "type": "printTable",
                        "column": [
                            4,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "label": "",
                        "value": "09:00",
                        "type": "printTable",
                        "column": [
                            4,
                            3
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isUnderline": false
                    },
                    {
                        "type": "printDashLine"
                    }
                ],
                "footer": [
                    {
                        "type": "setFontSize",
                        "size": 30
                    },
                    {
                        "label": "Total:",
                        "value": "4,000.00 GNF",
                        "type": "printTable",
                        "column": [
                            2,
                            4
                        ],
                        "align": [
                            0,
                            2
                        ],
                        "isBold": true,
                        "isUnderline": false
                    },
                    {
                        "type": "printEmptyLines",
                        "line": 1
                    },
                    {
                        "type": "barcode",
                        "value": "L-FAKETICKET",
                        "isShowCode": true,
                        "fontSize": 25,
                        "height": 80
                    },
                    {
                        "type": "printTextCustom",
                        "value": "Gains valides pendant 7 jours",
                        "fontSize": 20,
                        "isUnderline": false,
                        "alignment": 1,
                        "font": font
                    },
                    {
                        "type": "printTextCustom",
                        "value": "Fortune aux parieurs et",
                        "fontSize": 20,
                        "isUnderline": false,
                        "alignment": 1,
                        "font": font
                    },
                    {
                        "type": "printTextCustom",
                        "value": "Bénéfice à la nation",
                        "fontSize": 20,
                        "isUnderline": false,
                        "alignment": 1,
                        "font": font
                    },
                    {
                        "type": "printEmptyLines",
                        "line": 1
                    },
                    {
                        "type": "printTextCustom",
                        "value": "FIN",
                        "fontSize": 24,
                        "isUnderline": false,
                        "alignment": 1
                    },
                    {
                        "type": "cutPaper"
                    }
                ],
            }

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        async printResultItem(item, selectedGame) {
            const translatedGame = this.getTranslatedText(selectedGame || item.game)
            const translatedDrawName = this.getTranslatedText(item.draw_name)

            const logoImg = await this.loadLogoImage(LOTTO_LOGO)
            const image58 = this.buildResultImage(item, translatedGame, translatedDrawName, 50, logoImg)
            const image80 = this.buildResultImage(item, translatedGame, translatedDrawName, 70, logoImg)

            // Strip the `data:image/png;base64,` prefix so the value matches the
            // raw-base64 shape the native wrapper already expects from VUE_APP_LOGO_LOTTO_64.
            const stripDataUrl = (url) => url.replace(/^data:image\/\w+;base64,/, '')

            // Mirror ticket-print flow (`print-by-format` with a minimal printerData):
            // the whole result row is rendered as an image and passed via the `logo64`
            // slot. Native wrapper picks the 58mm or 80mm variant based on device paper.
            const printerData = {
                init: [{ type: 'setAlignCenter' }, { type: 'setAlign', alignConstant: 1 }],
                logo64: stripDataUrl(image58),
                body: [
                    { type: 'cutPaper' },
                ],
            }

            parent.postMessage({ command: 'print-by-format', data: printerData, ...buildSimulateErrorField() }, '*')

            // Debug: download the generated images so they can be inspected on the PC
            // this.downloadDataUrl(image58, `result-${translatedDrawName || 'item'}-58mm.png`)
            // this.downloadDataUrl(image80, `result-${translatedDrawName || 'item'}-80mm.png`)
        },

        loadLogoImage(src) {
            if (!src) return Promise.resolve(null)
            // Accept URL, data URL, or raw base64
            let normalized = src
            if (!/^(data:|https?:|\/)/i.test(src)) {
                normalized = `data:image/png;base64,${src}`
            }
            return new Promise((resolve) => {
                const img = new Image()
                // Required so the canvas stays un-tainted when loading a remote URL,
                // otherwise toDataURL() throws. Silently falls back to no-logo if CORS blocks.
                if (/^https?:/i.test(normalized)) img.crossOrigin = 'anonymous'
                img.onload = () => resolve(img)
                img.onerror = () => resolve(null)
                img.src = normalized
            })
        },

        downloadDataUrl(dataUrl, filename) {
            const a = document.createElement('a');
            a.href = dataUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        buildResultImage(item, gameName, drawName, paperWidthMm, logoImg) {
            // Thermal printer resolution: 203 DPI ≈ 8 px/mm.
            // Layout is designed horizontally (as the user sketched it); rotated 90° CW at the end.
            //   Row 1 (top):    [logo] [game name]        — side by side
            //   Row 2:          draw name: X - Draw date: Y
            //   Row 3 (large):  main numbers spread horizontally
            //                   optional double-chance row
            //   Row 4:          next draw / jackpot
            const PX_PER_MM = 8;
            const paperPx = paperWidthMm * PX_PER_MM; // AB side — source HEIGHT, rotated WIDTH

            const headerFontPx = Math.max(14, Math.round(paperPx * 0.08));
            const gameFontPx = Math.max(16, Math.round(paperPx * 0.1));
            const numberFontPx = Math.max(22, Math.round(paperPx * 0.14));
            const footerFontPx = Math.max(14, Math.round(paperPx * 0.08));
            const marginPx = 0;

            // Row-1 height is driven by logo/game size; other rows by their font.
            const row1H = Math.max(gameFontPx, paperPx * 0.22) + marginPx;
            const row2H = headerFontPx * 1.5;
            const numbersRowH = numberFontPx * 1.6;
            const row4H = footerFontPx * 1.5;

            // --- Strings -----------------------------------------------------
            const drawDateStr = item.draw_date ? this.renderDatePrint(item.draw_date, true, true) : '';
            const showDrawName = drawName && drawName.toLowerCase() !== gameName.toLowerCase();
            let drawInfoText = showDrawName ? `${this.getTranslatedText('draw name')}: ${drawName}` : '';
            if (drawDateStr) {
                if (drawInfoText) drawInfoText += ' - ';
                drawInfoText += `${this.getTranslatedText('draw Date')}: ${drawDateStr}`;
            }

            const results = Array.isArray(item.results) ? item.results : [];
            const row1Nums = results[0] && results[0].length ? results[0] : [];
            const row2Nums = results[1] && results[1].length ? results[1] : [];

            const dcResults = Array.isArray(item.double_chance_results) ? item.double_chance_results : [];
            const dcRow1Nums = dcResults[0] && dcResults[0].length ? dcResults[0] : [];
            const dcRow2Nums = dcResults[1] && dcResults[1].length ? dcResults[1] : [];
            const hasDc = dcRow1Nums.length > 0 || dcRow2Nums.length > 0;
            const dcLabel = hasDc ? 'DC:' : '';

            const nextDrawStr = item.jackpot_draw_date ? this.renderDatePrint(item.jackpot_draw_date, true, true) : '';
            const jackpotStr = (item.estimated_jackpot !== undefined && item.estimated_jackpot !== null && item.estimated_jackpot !== '')
                ? formatPrice(parseFloat(item.estimated_jackpot), 0) : '';
            let footerText = '';
            if (nextDrawStr) footerText += `${this.getTranslatedText('next draw')} (${nextDrawStr})`;
            if (jackpotStr) footerText += `${footerText ? ' ' : ''}${this.getTranslatedText('jackpot')}: ${jackpotStr}`;

            // --- Measure to size the canvas width (contentPx, i.e. BC, flexible) -----
            const meas = document.createElement('canvas').getContext('2d');
            const mw = (font, text) => { meas.font = font; return meas.measureText(text).width; };

            // Logo sizing: capped to row-1 height so it doesn't push other rows out
            let logoDrawW = 0, logoDrawH = 0;
            if (logoImg && logoImg.width && logoImg.height) {
                const maxH = row1H - marginPx * 0.5;
                const maxW = paperPx * 0.35;
                const scale = Math.min(maxH / logoImg.height, maxW / logoImg.width);
                logoDrawW = logoImg.width * scale;
                logoDrawH = logoImg.height * scale;
            }

            const gameTextW = gameName ? mw(`bold ${gameFontPx}px sans-serif`, String(gameName)) : 0;
            const row1W = logoDrawW + (logoDrawW && gameTextW ? marginPx : 0) + gameTextW;

            const row2TextW = mw(`${headerFontPx}px sans-serif`, drawInfoText);

            const numberFont = `bold ${numberFontPx}px sans-serif`;
            const numbersSpacing = numberFontPx * 0.8; // gap between numbers
            const dashStr = '-';
            const dashW = mw(numberFont, dashStr);

            // Measure a combined "set1 - set2" line width
            const measureLine = (set1, set2, prefix) => {
                let w = 0;
                if (prefix) w += mw(numberFont, prefix) + numbersSpacing;
                if (set1.length) w += set1.reduce((a, n) => a + mw(numberFont, String(n)), 0) + numbersSpacing * (set1.length - 1);
                if (set1.length && set2.length) w += numbersSpacing + dashW + numbersSpacing;
                if (set2.length) w += set2.reduce((a, n) => a + mw(numberFont, String(n)), 0) + numbersSpacing * (set2.length - 1);
                return w;
            };

            const resultLineW = measureLine(row1Nums, row2Nums, '');
            const dcLineW = hasDc ? measureLine(dcRow1Nums, dcRow2Nums, dcLabel) : 0;

            const footerTextW = footerText ? mw(`${footerFontPx}px sans-serif`, footerText) : 0;

            const innerMaxW = Math.max(row1W, row2TextW, resultLineW, dcLineW, footerTextW);
            const contentPx = Math.ceil(innerMaxW + 2 * marginPx);

            // Compute actual content height so the canvas is tight-fitted.
            const hasResult = row1Nums.length > 0 || row2Nums.length > 0;
            const numberRows = (hasResult ? 1 : 0) + (hasDc ? 1 : 0);
            const actualHeight = Math.ceil(
                row1H
                + (drawInfoText ? row2H : 0)
                + numberRows * numbersRowH
                + (footerText ? row4H : 0)
            );

            // --- Canvas ------------------------------------------------------
            const canvas = document.createElement('canvas');
            canvas.width = contentPx;
            canvas.height = actualHeight;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = '#000000';
            ctx.textBaseline = 'middle';

            const cx = canvas.width / 2;

            // Vertical stack — compute y-centers for each row from the top.
            let y = marginPx;

            // ---- Row 1: logo + game name ----
            const row1CenterY = y + row1H / 2;
            const row1Left = cx - row1W / 2;
            let xCursor = row1Left;
            if (logoImg && logoDrawW > 0) {
                ctx.drawImage(
                    logoImg,
                    xCursor,
                    row1CenterY - logoDrawH / 2,
                    logoDrawW, logoDrawH,
                );
                xCursor += logoDrawW + (gameTextW ? marginPx : 0);
            }
            if (gameName) {
                ctx.textAlign = 'left';
                ctx.font = `bold ${gameFontPx}px sans-serif`;
                ctx.fillText(String(gameName), xCursor, row1CenterY);
            }
            y += row1H;

            // ---- Row 2: draw name + draw date ----
            if (drawInfoText) {
                ctx.textAlign = 'center';
                ctx.font = `${headerFontPx}px sans-serif`;
                ctx.fillText(drawInfoText, cx, y + row2H / 2);
                y += row2H;
            }

            // ---- Row 3: results + optional DC — one line each ----
            const numbersStartY = y;

            // Draw "set1 - set2" on one line, with optional prefix (e.g. "DC:")
            const drawResultLine = (set1, set2, centerY, prefix) => {
                ctx.font = numberFont;
                ctx.textAlign = 'center';
                const lineW = measureLine(set1, set2, prefix);
                let nx = cx - lineW / 2;

                if (prefix) {
                    const pw = mw(numberFont, prefix);
                    ctx.fillText(prefix, nx + pw / 2, centerY);
                    nx += pw + numbersSpacing;
                }

                set1.forEach((n, i) => {
                    const nw = mw(numberFont, String(n));
                    ctx.fillText(String(n), nx + nw / 2, centerY);
                    nx += nw + numbersSpacing;
                });

                if (set1.length && set2.length) {
                    ctx.fillText(dashStr, nx + dashW / 2, centerY);
                    nx += dashW + numbersSpacing;
                }

                set2.forEach((n, i) => {
                    const nw = mw(numberFont, String(n));
                    ctx.fillText(String(n), nx + nw / 2, centerY);
                    nx += nw + numbersSpacing;
                });
            };

            let ny = numbersStartY;
            if (hasResult) {
                drawResultLine(row1Nums, row2Nums, ny + numbersRowH / 2, '');
                ny += numbersRowH;
            }
            if (hasDc) {
                drawResultLine(dcRow1Nums, dcRow2Nums, ny + numbersRowH / 2, dcLabel);
                ny += numbersRowH;
            }

            // ---- Row 4: next draw + jackpot ----
            if (footerText) {
                ctx.font = `${footerFontPx}px sans-serif`;
                ctx.textAlign = 'center';
                ctx.fillText(footerText, cx, ny + row4H / 2);
            }


            // Rotate 90° clockwise.
            // After rotation the pre-rotation left edge becomes the top of
            // the printed strip, and the pre-rotation top becomes the right
            // edge.  Thermal printers clip both edges on narrow 58 mm paper,
            // so we pad the rotated canvas and offset the drawn content so
            // the extra whitespace absorbs the clip on both sides.
            const padTop = 0;
            const padRight = 0;
            const rotated = document.createElement('canvas');
            rotated.width = canvas.height + padRight;
            rotated.height = canvas.width + padTop;
            const rctx = rotated.getContext('2d');
            rctx.fillStyle = '#ffffff';
            rctx.fillRect(0, 0, rotated.width, rotated.height);
            rctx.translate(rotated.width - padRight, padTop);
            rctx.rotate(Math.PI / 2);
            rctx.drawImage(canvas, 0, 0);

            return rotated.toDataURL('image/png');
        },

        printResult(data) {
            let printerData = {};

            printerData[logoKey] = LOTTO_LOGO;

            printerData['body'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('result'),
                    fontSize: 30,
                    isBold: true,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printDashLine',
                },
            ];

            for (let i = 0; i < data.length; i++) {
                let result = "";
                if (data[i].results && data[i].results[0]) {
                    result += data[i].results[0];
                }
                if (data[i].results && data[i].results[1]) {
                    result += "," + data[i].results[1];
                }

                let result2 = "";
                if (data[i].double_chance_results && data[i].double_chance_results[0]) {
                    result2 += data[i].double_chance_results[0];
                }
                if (data[i].double_chance_results && data[i].double_chance_results[1]) {
                    result2 += "," + data[i].double_chance_results[1];
                }
                // format("DD MMM YYYY HH:mm")}`
                let date = formatFromUTCStringToFrCustomString(data[i].draw_date);

                let bodies = [
                    {
                        type: "setAlignRight",
                    },
                    {
                        type: "printTextCustom",
                        value: date,
                        alignment: 2,
                    },
                    {
                        type: "setAlignLeft",
                    },
                    {
                        type: "printTextCustom",
                        value: `${data[i].draw_name}`,
                        alignment: 0,
                    },
                    {
                        type: "setAlignRight",
                    },
                    {
                        type: "printTextCustom",
                        value: `${result.replace(/,/g, ', ')}`,
                        alignment: 2,
                    },
                ];

                if (result2 != '') {
                    bodies.push({
                        type: "printTextCustom",
                        value: `DC: ${result2.replace(/,/g, ', ')}`,
                        alignment: 2,
                    });
                }

                bodies.push({
                    type: "printDashLine",
                })

                printerData["body"] = [...printerData["body"], ...bodies];
            }

            printerData["body"] = [
                ...printerData["body"],
                ...[
                    {
                        type: "cutPaper",
                    },
                ],
            ];

            parent.postMessage(
                {
                    command: 'print-by-format',
                    data: printerData,
                    ...buildSimulateErrorField(),
                },
                '*'
            );
        },

        renderDatePrint(date, isNotShowSeconds = false, isNotShowTime = false) {
            const dateFormat = formatDateUTC00(date);
            let valueDate = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}:${dateFormat.seconds}`;

            if (isNotShowSeconds) {
                valueDate = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;
            }

            if (isNotShowTime) {
                valueDate = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year}`;
            }

            return valueDate;
        },

        convertDateString(input) {
            const year = input.substr(0, 4);
            const month = input.substr(4, 2);
            const day = input.substr(6, 2);

            const output = `${day}/${month}/${year}`;
            return output;
        },

        isMobiDevice() {
            let device = getSettingDevice()
            if (!isStrEmpty(device)) {
                device = JSON.parse(device)
            }
            if (device?.serial?.startsWith('tb8765ap1_64_bsp')) {
                return true;
            }
            return false;
        },

        isCheckFontMobile() {
            return this.isMobiDevice() ? "1" : ""
        },
    },
};
